import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-page-title',
    templateUrl: './page-title.component.html',
    styleUrls: ['./page-title.component.scss'],
    standalone: false
})
export class PageTitleComponent implements OnInit {

  @Input() title: string;
  @Input() subtitle: string;

  constructor( ) { }

  ngOnInit() { }
}
